import { createEntityAdapter } from '@reduxjs/toolkit';
import { AffiliateProgramEntity } from 'app/interfaces/entity';
import { AffiliateProgramsState } from './interfaces';
import { AffiliateProgramsStoreStatus } from './enums';

export const entityAdapter = createEntityAdapter<AffiliateProgramEntity>({
  selectId: (data) => data.id,
});

export const initialState: AffiliateProgramsState = entityAdapter.getInitialState({
  status: {
    [AffiliateProgramsStoreStatus.Loading]: [],
    [AffiliateProgramsStoreStatus.Updating]: [],
    [AffiliateProgramsStoreStatus.Creating]: [],
    [AffiliateProgramsStoreStatus.StatisticLoading]: [],
  },
  limit: 50,
  offset: 0,
  total: 0,
  reload: false,
});
